// AutoAI code
import React, { useCallback, useRef, useState, useEffect } from "react";
import Webcam from "react-webcam";
import microphoneSlash from "../../../../assets/image/microphone_slash.svg";
import microphone from "../../../../assets/image/microphone.svg";
import endCall from "../../../../assets/image/end_call.svg";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import apiCall from "../../../../utils/axiosCall";
import { useParams } from "react-router-dom";
import { endPoint } from "../../../../utils/endPoint";
import welcome_Message from "../../../../assets/audio/welcome.json";
import { usePopupModal } from "../../../../context/PopupModelContext";
import { useInterviewSecurity } from "../../../../utils/useInterviewSecurity";

const audioContext = new (window.AudioContext || window.webkitAudioContext)();
// Shared across every getStreamAudio() call so the AI audio stream fed to the
// recorder keeps the same identity for the whole interview instead of a new
// MediaStream being created (and the recorder restarted) on every question turn.
const aiAudioDestination = audioContext.createMediaStreamDestination();

const Video = ({
  pauseRecord,
  startRecord,
  pauseRecording,
  resumeRecording,
  recordingPermission,
  stopDisable,
  stop,
  setChat,
  chat,
  setMicrophone,
  setWriteAi,
  setAiAudioStream,
  callcut,
  handle,
  isFullScreen,
  setIsFullScreen,
  setPopupendCall,
  setCurrentInterviewStatus,
}) => {
  let { uuid } = useParams();
  const audioRef = useRef(new Audio());
  const webcamRef = useRef(null);
  const [message, setMessage] = React.useState("");
  const [sessionID, SetSessionID] = useState(
    "763a9ec4-bc43-4770-8436-ff09b5e94ba5"
  );
  const [conversationData, SetConversationData] = useState();
  let audio = new Audio();
  const [aiAudioPlay, setAiAudioPlay] = useState(false);
  const [currentChat, setCurrentChat] = useState([]);
  const [isCurrentConversationFetched, setIsCurrentConversationFetched] =
    useState(false);
  const [endcallPopup, setEndcallPopup] = useState(false);

  const { isOpen, setIsOpen } = usePopupModal();
  const [validationMessage, setValidationMessage] = useState("");
  let count = 0;
  let interviewStatus = localStorage.getItem("interview_status");
  const current_session_id = localStorage.getItem("session_id");
  var interview_timing_id = localStorage.getItem("interview_timing_id", -1);

  const [isInactive, setIsInactive] = useState(false);
  const [audioSource, setAudioSource] = useState(false);
  const [finalConnentDetail, setFinalConnentDetail] = useState("");

  const [isMicDisabled, setIsMicDisabled] = useState(false);

    // New state for Interview Timer
    const [interviewDuration, setInterviewDuration] = useState(0); // Will be set from API
    const [timeRemaining, setTimeRemaining] = useState(0); // Will be set from API
    const timerRef = useRef(null); // Ref for the interval timer

    const [isTimerLoaded, setIsTimerLoaded] = useState(false);
    const [fullScreen, setFullScreen] = useState(!!document.fullscreenElement);

    // First useEffect - Runs once on component mount
    useEffect(() => {
        // Set microphone to false when component first loads
        console.log("Component mounted - disabling microphone");
        setMicrophone(false);
        SpeechRecognition.stopListening();
        setIsMicDisabled(true);
    }, []); // Empty dependency array

    // Second useEffect - Keeps mic disabled until interview starts
    useEffect(() => {
        if (!startRecord) {
            // Interview hasn't started yet - keep mic disabled
            setMicrophone(false);
            SpeechRecognition.stopListening();
            setIsMicDisabled(true);
        }
    }, [startRecord]);

    const handleEndCallClickRef = useRef(null);
    useInterviewSecurity(fullScreen, () => {
        if (handleEndCallClickRef.current) {
            handleEndCallClickRef.current();
        }
    }, startRecord);

  // Remove auto-submit timer
  const inactivityTimerRef = useRef(null);
  var inactivityTimeOut = 90000;
  var popupTimeOut = 60000;
  var showPopupTimeOut = 60000;

  let inactivityTimer;
  let popupTimer;
  let showPopupTimer;
  var terminatedPopupTimeout = 90000000;
  const terminatedPopupTimer = useRef(null);

  const [isFetchingQuestion, setIsFetchingQuestion] = useState(false);

  // New state for accumulated transcript
  const [accumulatedTranscript, setAccumulatedTranscript] = useState("");
  
  // New state to track if this is the last question
  const [isLastQuestion, setIsLastQuestion] = useState(false);
  // Add new state at the top of component (around line 96)
  const [isProcessingNextQuestion, setIsProcessingNextQuestion] = useState(false);

  const resetTimer = useCallback(() => {
    setIsInactive(false);
    clearTimeout(inactivityTimer);
    clearTimeout(popupTimer);
    clearTimeout(showPopupTimer);
    startTimers();
  }, []);

  const startTimers = () => {
    inactivityTimer = setTimeout(() => {
      setIsInactive(true);
    }, inactivityTimeOut);
  };

  useEffect(() => {
  const fetchInterviewInfo = async () => {
    if (!current_session_id) return;
    
    const response = await apiCall({
      url: endPoint.AUTOSCREEN_FETCH_INTERVIEW_INFO,
      method: "post",
      data: JSON.stringify({ session_id: current_session_id }),
    });
    console.log("response:",response);
    // Convert MM.SS format to seconds
    const timerValue = response?.result?.timer || 30;
    const minutes = Math.floor(timerValue);
    const seconds = Math.round((timerValue - minutes) * 100);
    const totalSeconds = (minutes * 60) + seconds;
    console.log("totalSeconds:",totalSeconds);
    setInterviewDuration(totalSeconds);
    setTimeRemaining(totalSeconds);
    setIsTimerLoaded(true); // Mark timer as loaded
  };
  
  fetchInterviewInfo();
}, [current_session_id]);

  useEffect(() => {
    if (isOpen) {
      console.log("called.....", isOpen);
      terminatedPopupTimer.current = setTimeout(() => {
        handleEndCallClick();
      }, terminatedPopupTimeout);
    } else {
      console.log("clearTimeout.....", isOpen);
      console.log("terminatedPopupTimer.....", terminatedPopupTimer);
      clearTimeout(terminatedPopupTimer.current);
      terminatedPopupTimer.current = null;
    }
    return () => clearTimeout(terminatedPopupTimer.current);
  }, [isOpen]);

  useEffect(() => {
    startTimers();
    return () => {
      clearTimeout(showPopupTimer);
      clearTimeout(inactivityTimer);
      clearTimeout(popupTimer);
    };
  }, [resetTimer]);

  function base64ToArrayBuffer(base64) {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    hours = String(hours).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  const getConversationData = async (userAnswer, isSkipped = false) => {
    console.log("getConversationData called:", { userAnswer, isSkipped });

    clearTimeout(popupTimer);
    startTimers();
    const currentQuestionId = parseInt(
      localStorage.getItem("autoscreen_curr_que")
    );

    console.log("Current Question ID from localStorage:", {
      raw: localStorage.getItem("autoscreen_curr_que"),
      parsed: currentQuestionId,
      isValid: !!currentQuestionId
    });

    if (currentQuestionId) {
      const now = new Date();
      const formattedTime = formatDate(now);

      let answerData = {
        question_id: currentQuestionId,
        answer: isSkipped ? "[SKIPPED]" : userAnswer,
        answer_timestamp: formattedTime ? formattedTime : "",
      };

      console.log("Attempting to save answer:", answerData);

      const JsonData = {
        url: endPoint.AUTOSCREEN_UPDATE_ANSWER,
        method: "post",
        data: JSON.stringify(answerData),
      };

      const answerResponse = await apiCall(JsonData);

      // CRITICAL FIX: Validate answer was saved successfully
      console.log("Answer save response:", {
        currentQuestionId,
        isSkipped,
        answer: isSkipped ? "[SKIPPED]" : userAnswer,
        response: answerResponse
      });

      // Check if the API call failed at network level
      if (answerResponse?.error && !answerResponse?.success) {
        console.error("Failed to save answer (network error):", answerResponse);
        throw new Error(answerResponse?.message || "Failed to save answer. Please try again.");
      }

      // Check if server returned an error return_code
      if (answerResponse?.return_code && answerResponse.return_code.includes("error")) {
        console.error("Failed to save answer (server error):", answerResponse);
        throw new Error(answerResponse?.message || "Server failed to save answer. Please try again.");
      }

      console.log("Answer saved successfully for question:", currentQuestionId);

      const autoscreen_next_id = localStorage.getItem("autoscreen_next_que");
      if (autoscreen_next_id === "null") {
        handleEndCallClick();
        return;
      }
    } else {
      console.warn("No current question ID found - answer NOT saved!", {
        isSkipped,
        userAnswer,
        localStorage_autoscreen_curr_que: localStorage.getItem("autoscreen_curr_que")
      });
    }

    let conversationData = {
      session_id: current_session_id,
      question_id: parseInt(localStorage.getItem("autoscreen_next_que")) || -1,
    };

    const JsonData = {
      url: endPoint.AUTOSCREEN_GET_QUESTIONS,
      method: "post",
      data: JSON.stringify(conversationData),
    };
    var apiResponse = await apiCall(JsonData);
    if (apiResponse?.return_code === "") {
    }
    SetConversationData(apiResponse?.result);
    localStorage.setItem(
      "autoscreen_next_que",
      apiResponse?.result?.next_question_id
    );
    localStorage.setItem(
      "autoscreen_curr_que",
      apiResponse?.result?.question_id
    );
    localStorage.setItem(
      "interview_status",
      apiResponse?.result?.interview_status
    );
    console.log(
      "apiResponse?.result?.interview_timing_id",
      apiResponse?.result?.interview_timing_id
    );
    if (interview_timing_id !== apiResponse?.result?.interview_timing_id) {
      localStorage.setItem(
        "interview_timing_id",
        apiResponse?.result?.interview_timing_id
      );
    }
    
    // Check if next_question_id is null, meaning this is the last question
    if (apiResponse?.result?.next_question_id === null || apiResponse?.result?.next_question_id === "null") {
      setIsLastQuestion(true);
    } else {
      setIsLastQuestion(false);
    }
    
    clearTimeout(popupTimer);
    resetTimer();
    return apiResponse;
  };
  var countInterview = 1;

  useEffect(() => {
    var getSessionData = async () => {
      try {
        const JsonData = {
          url: `${endPoint.GET_SESSION_INFO}${uuid}`,
          method: "get",
        };
        const sessionValue = await apiCall(JsonData);
        localStorage.setItem("session_id", sessionValue.result.session_id);
        localStorage.setItem("uuid", sessionValue.result.interview_id);
        localStorage.setItem("interview_id", sessionValue.result.interview_id);
        localStorage.setItem(
          "interview_status",
          sessionValue.result.interview_status
        );
      } catch (error) {
        const setInterviewStatus = localStorage.setItem(
          "interview_status",
          "completed"
        );
        setPopupendCall(true);
        setIsFullScreen(false);
        handle.exit();
      }
    };

    if (!current_session_id) {
      getSessionData();
    }

    const checkInterviewStatus = async () => {
        if (interviewStatus === "not_started") {
            setIsCurrentConversationFetched(true);
        }
        if (interviewStatus === "in_progess") {
            let data = {
                session_id: current_session_id,
                interview_type: localStorage.getItem("resourceful_interview_type"),
            };

            const JsonData = {
                url: endPoint.AUTOSCREEN_FETCH_CURRENT_CONVERSATION,
                method: "post",
                data: JSON.stringify(data),
            };
            var apiResponse = await apiCall(JsonData);

            if (apiResponse.return_code === "fetched_current_conversation_success") {
                const output_data = [];
                let chatData = apiResponse?.result?.conversation_data;
                
                if (chatData) {
                    console.log("chatData", chatData);
                    chatData.forEach((item) => {
                        const questionObj = {
                            type: "ai",
                            message: item.question,
                            createdAt: item.formatted_question_timestamp,
                            questionID: item.question_id,
                        };
                        output_data.push(questionObj);
                        if (item.answer) {
                            const answerObj = {
                            type: "user",
                            message: item.answer,
                            createdAt: item.formatted_answer_timestamp,
                            questionID: item.question_id,
                            };

                            output_data.push(answerObj);
                        }
                    });
                    localStorage.setItem(
                    "autoscreen_next_que",
                    apiResponse?.result?.next_question_id
                    );

                let last_object = output_data.slice(-1)[0];
                localStorage.setItem("autoscreen_curr_que", last_object.questionID);
                
                // FIX: Check if we need to fetch the next question
                // This happens when the last message is a user response (including [SKIPPED])
                    if (last_object?.type === "user") {
                    console.log("Last message is user response - fetching next question");
                    
                    // Disable microphone while fetching
                    setMicrophone(false);
                    SpeechRecognition.stopListening();
                    setIsMicDisabled(true);
                    
                    try {
                        // Fetch the next question
                        const response = await getConversationData("", false);
                        
                        if (response?.result?.question) {
                            const AiQuestion = response?.result?.question;
                            const questionID = response?.result?.question_id;
                            const now = new Date();
                            const datetime = getCurrentTime();
                            const time = getTimeOnly(datetime);
                            
                            const questionObj = {
                                type: "ai",
                                message: AiQuestion,
                                createdAt: time,
                                questionID: questionID,
                                createdDateTimeAt: datetime,
                            };
                            
                            output_data.push(questionObj);
                            
                            // Get audio for the new question
                            const audioData = {
                                question_id: questionID,
                                text: AiQuestion,
                                interview_type: localStorage.getItem("resourceful_interview_type"),
                            };
                            
                            const audioJsonData = {
                                url: endPoint.FETCH_AUDIO,
                                method: "post",
                                data: JSON.stringify(audioData),
                            };
                            
                            const audioResponse = await apiCall(audioJsonData);
                            SetConversationData(audioResponse?.result);
                            
                            // Play the audio
                            getStreamAudio(audioResponse?.result?.audio);
                        }
                    } catch (error) {
                        console.error("Error fetching next question on resume:", error);
                        // Enable mic on error so user isn't stuck
                        setIsMicDisabled(false);
                        listenContinuously();
                    }
                }
                // Original code for when last message is AI
                    else if (last_object?.type === "ai") {
                    console.log("Last message is AI question - replaying audio");
                    
                    // Disable microphone while playing audio
                    setMicrophone(false);
                    SpeechRecognition.stopListening();
                    setIsMicDisabled(true);
                    
                    const getTextAudioData = async () => {
                        let data = {
                            question_id: last_object.questionID,
                            text: last_object.message,
                            interview_type: localStorage.getItem(
                                "resourceful_interview_type"
                            ),
                        };

                        const JsonData = {
                            url: endPoint.FETCH_AUDIO,
                            method: "post",
                            data: JSON.stringify(data),
                        };
                        var apiResponse = await apiCall(JsonData);
                        SetConversationData(apiResponse?.result);

                        return apiResponse;
                    };

                    const fetchData = async () => {
                        const response = await getTextAudioData(last_object.message);
                        return response;
                    };

                    const response = await fetchData();

                    getStreamAudio(response?.result?.audio);
                }

                setChat(output_data);
                setCurrentChat(output_data);
                count += 1;
                setIsCurrentConversationFetched(true);
            }
            }
        }
    };
    if (countInterview === 1) {
      checkInterviewStatus();
      countInterview += 2;
      listenContinuously();
    }
  }, []);

  useEffect(() => {
    const updateTimeStamp = async (currentChat) => {
      let question_timestamp;
      let answer_timestamp = "";
      let questionID;
      for (let i = chat.length - 1; i >= 0; i--) {
        const message = chat[i];
        if (message.type === "user") {
          answer_timestamp = message.createdDateTimeAt;
        }

        if (message.type === "ai") {
          question_timestamp = message.createdDateTimeAt;
          questionID = message.questionID;
        }

        if (questionID && question_timestamp) {
          break;
        }
      }
      if (questionID && question_timestamp) {
        let data = {
          question_id: questionID,
          question_timestamp: question_timestamp,
          answer_timestamp: answer_timestamp,
          interview_type: localStorage.getItem("resourceful_interview_type"),
        };
        const JsonData = {
          url: endPoint.UPDATE_TIMESTAMP,
          method: "post",
          data: JSON.stringify(data),
        };
        var apiResponse = await apiCall(JsonData);
        return;
      }
    };
    updateTimeStamp(currentChat);
  }, [currentChat]);

  const getCurrentTime = () => {
    const date = new Date();
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    let timeFormat = "24";
    let meridiem = "";
    if (hours > 12) {
      hours -= 12;
      meridiem = "PM";
      timeFormat = "12";
    } else if (hours === 0) {
      hours = 12;
      meridiem = "AM";
      timeFormat = "12";
    } else {
      meridiem = "AM";
    }

    hours = hours < 10 ? `0${hours}` : hours;
    const formattedTime = `${hours}:${minutes < 10 ? `0${minutes}` : minutes}:${
      seconds < 10 ? `0${seconds}` : seconds
    }`;
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day} ${formattedTime} ${
      timeFormat === "12" ? meridiem : "AM"
    }`;
  };

  const getTimeOnly = (dateTimeStr) => {
    return dateTimeStr.split(" ")[1] + " " + dateTimeStr.split(" ")[2];
  };

  const videoConstraints = {
    width: 2000,
    height: 920,
    facingMode: "user",
  };

  const commands = [
    {
      command: "reset",
      callback: () => resetTranscript(),
    },
    {
      command: "shut up",
      callback: () => setMessage("I wasn't talking."),
    },
    {
      command: "Hello",
      callback: () => setMessage("Hi there!"),
    },
  ];

  const {
    transcript,
    interimTranscript,
    finalTranscript,
    resetTranscript,
    listening,
  } = useSpeechRecognition({ commands });

  useEffect(() => {
    if (callcut === true) {
      handleEndCallClick();
    }
  }, [callcut]);

  // Handle Next button click - submit current answer and fetch next question
  const handleNextQuestion = useCallback(async () => {
    if (isFetchingQuestion) return;

    const userAnswer = accumulatedTranscript.trim() || transcript.trim();
    
    if (!userAnswer) {
        setValidationMessage("Please provide an answer before moving to the next question.");
        setIsOpen(true);   // open popup
      return;
    }
    // STEP 1: Set flag to prevent transcript accumulation
    setIsProcessingNextQuestion(true);

    // STEP 2: IMMEDIATELY stop listening and clear everything
    SpeechRecognition.stopListening();
    setMicrophone(false);
    
    // STEP 3: Clear all transcript states
    resetTranscript();
    setAccumulatedTranscript("");

    // STEP 4: Small delay to ensure cleanup completes
    await new Promise(resolve => setTimeout(resolve, 100));

    // audioOff();
    const datetime = getCurrentTime();
    const time = getTimeOnly(datetime);

    if (Array.isArray(chat)) {
      chat.push({
        type: "user",
        message: userAnswer,
        createdAt: time,
        createdDateTimeAt: datetime,
      });
      setChat([...chat]);
      setCurrentChat([...chat]);
    } else {
      const newChatObject = {
        type: "user",
        message: userAnswer,
        createdAt: time,
        createdDateTimeAt: datetime,
      };
      setChat((prevChats) => [...prevChats, newChatObject]);
      setCurrentChat((prevChats) => [...prevChats, newChatObject]);
    }

    // resetTranscript();
    // setAccumulatedTranscript("");
    setWriteAi(true);
    setIsFetchingQuestion(true);

    try {
      const response = await getConversationData(userAnswer, false);
      const AiQuestion = response?.result?.question;
      const questionID = response?.result?.question_id;
      const datetime = getCurrentTime();
      const time = getTimeOnly(datetime);

      if (response.return_code === "interview_started_sucess") {
        if (Array.isArray(chat)) {
          chat.push({
            type: "ai",
            message: AiQuestion,
            createdAt: time,
            questionID: questionID,
            createdDateTimeAt: datetime,
          });
          setChat([...chat]);
          setCurrentChat([...chat]);
        } else {
          const newChatObject = {
            type: "ai",
            message: AiQuestion,
            createdAt: time,
            questionID: questionID,
            createdDateTimeAt: datetime,
          };
          setChat((prevChats) => [...prevChats, newChatObject]);
          setCurrentChat((prevChats) => [...prevChats, newChatObject]);
        }
      }

      setWriteAi(false);
      let audioContent =
        response.return_code === "interview_started_sucess"
          ? response?.result?.response_audio
          : null;
      await getStreamAudio(audioContent);

      setIsFetchingQuestion(false);

      // STEP 5: Clear transcripts again before restarting
      resetTranscript();
      setAccumulatedTranscript("");

      // STEP 6: Reset the flag AFTER everything is done
      setIsProcessingNextQuestion(false);

      // STEP 7: Restart listening with delay (handled by getStreamAudio onended)
      // Remove: if (listening) setMicrophone(true);

      if (response?.result?.interview_status === "completed") {
        await handleEndCallClick();
        if (webcamRef.current) {
          webcamRef.current = null;
        }
        console.log("stopListeningggggggggggggggggggg");
        SpeechRecognition.stopListening();
        setAiAudioPlay(false);
        stop();
      }
    } catch (error) {
      console.error("Error in handleNextQuestion:", error);

      // Show user-friendly error message
      alert(`Failed to save your answer: ${error.message}\n\nPlease check your internet connection and try again.`);

      // Reset states so user can try again
      setIsFetchingQuestion(false);
      setIsProcessingNextQuestion(false);
      setWriteAi(false);

      // Restore the transcript so user doesn't lose their answer
      // Don't clear the accumulated transcript on error

      // Re-enable microphone
      setMicrophone(true);
      listenContinuously();
    }
  }, [accumulatedTranscript, transcript, isFetchingQuestion, chat]);

  // Handle Finish button click - submit final answer and end interview
  const handleFinishInterview = useCallback(async () => {
    if (isFetchingQuestion) return;

    const userAnswer = accumulatedTranscript.trim() || transcript.trim();
    
    if (!userAnswer) {
      handleSkipQuestion()
      return;
    }

    audioOff();
    const datetime = getCurrentTime();
    const time = getTimeOnly(datetime);

    if (Array.isArray(chat)) {
      chat.push({
        type: "user",
        message: userAnswer,
        createdAt: time,
        createdDateTimeAt: datetime,
      });
      setChat([...chat]);
      setCurrentChat([...chat]);
    } else {
      const newChatObject = {
        type: "user",
        message: userAnswer,
        createdAt: time,
        createdDateTimeAt: datetime,
      };
      setChat((prevChats) => [...prevChats, newChatObject]);
      setCurrentChat((prevChats) => [...prevChats, newChatObject]);
    }

    resetTranscript();
    setAccumulatedTranscript("");
    setWriteAi(true);
    setIsFetchingQuestion(true);

    try {
      // Submit the final answer
      const currentQuestionId = parseInt(
        localStorage.getItem("autoscreen_curr_que")
      );
      if (currentQuestionId) {
        const now = new Date();
        const formattedTime = formatDate(now);

        let answerData = {
          question_id: currentQuestionId,
          answer: userAnswer,
          answer_timestamp: formattedTime ? formattedTime : "",
        };
        const JsonData = {
          url: endPoint.AUTOSCREEN_UPDATE_ANSWER,
          method: "post",
          data: JSON.stringify(answerData),
        };

        const answerResponse = await apiCall(JsonData);

        // CRITICAL FIX: Validate final answer was saved successfully
        console.log("Final answer save response:", {
          currentQuestionId,
          answer: userAnswer,
          response: answerResponse
        });

        // Check if the API call failed at network level
        if (answerResponse?.error && !answerResponse?.success) {
          console.error("Failed to save final answer (network error):", answerResponse);
          throw new Error(answerResponse?.message || "Failed to save your final answer. Please try again.");
        }

        // Check if server returned an error return_code
        if (answerResponse?.return_code && answerResponse.return_code.includes("error")) {
          console.error("Failed to save final answer (server error):", answerResponse);
          throw new Error(answerResponse?.message || "Server failed to save your final answer. Please try again.");
        }

        console.log("Final answer saved successfully for question:", currentQuestionId);
      }

      setWriteAi(false);
      setIsFetchingQuestion(false);

      // End the interview
      await handleEndCallClick();
      if (webcamRef.current) {
        webcamRef.current = null;
      }
      SpeechRecognition.stopListening();
      setAiAudioPlay(false);
      stop();
    } catch (error) {
      console.error("Error in handleFinishInterview:", error);

      // Show user-friendly error message
      alert(`Failed to save your final answer: ${error.message}\n\nPlease check your internet connection and try again.`);

      // Reset states so user can try again
      setIsFetchingQuestion(false);
      setWriteAi(false);

      // Don't clear the transcript so user doesn't lose their answer
      // Don't end the interview if save failed - let user retry
    }
  }, [accumulatedTranscript, transcript, isFetchingQuestion, chat]);

    // Handle Skip button click - skip current question
    const handleSkipQuestion = useCallback(async () => {
		console.log("Skip button clicked");

		if (isFetchingQuestion) {
			console.log("Skip blocked - already fetching question");
			return;
		}

		console.log("Processing skip question...", {
			currentQuestionId: localStorage.getItem("autoscreen_curr_que"),
			nextQuestionId: localStorage.getItem("autoscreen_next_que")
		});

		audioOff();
		const datetime = getCurrentTime();
		const time = getTimeOnly(datetime);

		if (Array.isArray(chat)) {
			chat.push({
				type: "user",
				message: "[SKIPPED]",
				createdAt: time,
				createdDateTimeAt: datetime,
			});
			setChat([...chat]);
			setCurrentChat([...chat]);
		} else {
			const newChatObject = {
				type: "user",
				message: "[SKIPPED]",
				createdAt: time,
				createdDateTimeAt: datetime,
			};
			setChat((prevChats) => [...prevChats, newChatObject]);
			setCurrentChat((prevChats) => [...prevChats, newChatObject]);
		}

		resetTranscript();
		setAccumulatedTranscript("");
		setWriteAi(true);
		setIsFetchingQuestion(true);

		try {
			const response = await getConversationData("", true);

			// FIX: Validate response exists
			if (!response) {
				throw new Error("No response received from server");
			}

			console.log("Skip response:", response);

    		// Check if interview is completed
    		if (response?.result?.interview_status === "completed" || response?.result?.next_question_id === null || response?.result?.next_question_id === "null") {
				console.log("Interview completed after skip");
				setWriteAi(false);
				setIsFetchingQuestion(false);
      
				await handleEndCallClick();
				if (webcamRef.current) {
					webcamRef.current = null;
				}
				SpeechRecognition.stopListening();
				setAiAudioPlay(false);
				stop();
				return; // Exit early
			}

			// Get the next question
			const AiQuestion = response?.result?.question;
			const questionID = response?.result?.question_id;

			// Validate we got a question
			if (!AiQuestion || !questionID) {
				throw new Error("Invalid question data received");
			}

			const newDatetime = getCurrentTime();
			const newTime = getTimeOnly(newDatetime);

			if (response.return_code === "interview_started_sucess") {
				if (Array.isArray(chat)) {
					chat.push({
						type: "ai",
						message: AiQuestion,
						createdAt: newTime,
						questionID: questionID,
						createdDateTimeAt: newDatetime,
					});
					setChat([...chat]);
					setCurrentChat([...chat]);
				} else {
					const newChatObject = {
						type: "ai",
						message: AiQuestion,
						createdAt: newTime,
						questionID: questionID,
						createdDateTimeAt: newDatetime,
					};
					setChat((prevChats) => [...prevChats, newChatObject]);
					setCurrentChat((prevChats) => [...prevChats, newChatObject]);
				}
			}

			setWriteAi(false);

			let audioContent = response.return_code === "interview_started_sucess" ? response?.result?.response_audio : null;

			getStreamAudio(audioContent);
			setIsFetchingQuestion(false);

		} catch (error) {
			console.error("Error in handleSkipQuestion:", error);

			// Show user-friendly error message
			alert(`Failed to skip question: ${error.message}\n\nPlease check your internet connection and try again.`);

			// Reset states so user can try again
			setIsFetchingQuestion(false);
			setWriteAi(false);

			// Remove the [SKIPPED] message from chat since skip failed
			if (Array.isArray(chat)) {
				const filteredChat = chat.filter(msg => msg.message !== "[SKIPPED]" || msg.type !== "user");
				setChat(filteredChat);
				setCurrentChat(filteredChat);
			}

			// Re-enable microphone
			setMicrophone(true);
			listenContinuously();
		}
	}, [isFetchingQuestion, chat]);

	// Improved transcript handling - accumulate all transcripts
	useEffect(() => {
		if (finalTranscript && !isFetchingQuestion && !isProcessingNextQuestion) {
			// Append new transcript to accumulated transcript
			setAccumulatedTranscript((prev) => {
				const newTranscript = prev + (prev ? " " : "") + finalTranscript.trim();
				return newTranscript;
			});

			// Reset the speech recognition transcript
			resetTranscript();
		}
	}, [finalTranscript, isFetchingQuestion, isProcessingNextQuestion, resetTranscript]);

	// Display current transcript (accumulated + interim)
	const displayTranscript = accumulatedTranscript + (accumulatedTranscript && interimTranscript ? " " : "") + interimTranscript;

  useEffect(() => {
    const fetchData = async () => {
      let interviewTimingId =
        localStorage.getItem("interview_timing_id") || -1;

      if (interviewTimingId === undefined || interviewTimingId === null) {
        interviewTimingId = -1;
      }
      let recordTimeData = {
        session_id: current_session_id,
        interview_timing_id: interviewTimingId,
        end_time: new Date().toISOString(),
      };
      const JsonData = {
        url: endPoint.AUTOSCREEN_RECORD_INTERVIEW_TIME,
        method: "post",
        data: JSON.stringify(recordTimeData),
      };
      var InterviewTimingValueResponse = await apiCall(JsonData);
      if (
        InterviewTimingValueResponse?.return_code ===
        "fetched_interview_timing_success"
      ) {
        if (
          InterviewTimingValueResponse?.result?.interview_timing_id !==
          interview_timing_id
        ) {
          localStorage.setItem(
            "interview_timing_id",
            InterviewTimingValueResponse?.result?.interview_timing_id
          );
        }
      } else {
      }
    };
    const intervalId = setInterval(() => {
      fetchData();
    }, 1000 * 5);
    resetTimer();
    return () => clearInterval(intervalId);
  }, []);

    useEffect(() => {
        const fetchData = async () => {
            if (isCurrentConversationFetched) {
                count += 1;
                try {
                    setWriteAi(true);
                    const response = await getConversationData("Hello, how are you");
                    const datetime = getCurrentTime();
                    const time = getTimeOnly(datetime);
                    SetSessionID(response?.result?.session_id);
                    const messageAi = response?.result?.question;
                    const questionID = response?.result?.question_id;
                    if (Array.isArray(chat)) {
                        chat.push({
                            type: "ai",
                            message: messageAi,
                            createdAt: time,
                            createdDateTimeAt: datetime,
                            questionID: questionID,
                        });
                        setChat([...chat]);
                        setCurrentChat([...chat]);
                    } else {
                        setChat([finalTranscript]);
                        setCurrentChat([finalTranscript]);
                    }

                    let audioContent;
                    if (response.return_code === "interview_started_sucess") {
                        audioContent = response?.result?.response_audio;
                    } else {
                        audioContent = null;
                    }
                    getStreamAudio(audioContent);
                    setWriteAi(false);
                } catch (error) {
                    setWriteAi(false);
                    console.error("Error fetching conversation data:", error);
                }
            }
            setWriteAi(false);
        };
        if (startRecord && chat.length === 0) {
            if (window.performance) {
                if (performance.navigation.type === 1) {
                } else {
                    console.log("758interviewStatus", interviewStatus);
                    if (interviewStatus === "not_started") {
                        setMicrophone(false);
                        SpeechRecognition.stopListening();
                        const byteCharacters = atob(welcome_Message.audioContent);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], { type: "audio/mp3" });

                        const audioUrl = URL.createObjectURL(blob);
                        const audio = new Audio(audioUrl);
                        audio.play();
                        let audio_time = null;
                        audio.addEventListener("loadedmetadata", () => {
                            audio_time = audio.duration;
                        });
                    }
                }
            }
            setTimeout(() => {
                fetchData();
            }, 4000);
        }
    }, [startRecord, isCurrentConversationFetched]);

  
    useEffect(() => {
        const checkFullScreen = () => {
            setFullScreen(!!document.fullscreenElement);
        };

        document.addEventListener("fullscreenchange", checkFullScreen);
        return () => {
            document.removeEventListener("fullscreenchange", checkFullScreen);
        };
    }, []);

    useEffect(() => {
        if (!fullScreen) {
            audioOff();
        } else {
            listenContinuously();
        }
    }, [fullScreen]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (fullScreen) {
                if (e.key === "Escape") return;
                e.preventDefault();
                e.stopPropagation();
                handleEndCallClick();
            }
        };
    }, [fullScreen]);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                handleEndCallClick();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
        alert(
        "Your browser does not support speech recognition software! Try Chrome desktop, maybe?"
        );
    }

    let isAudioplaying = false;
    // Starting at line 1000
    const listenContinuously = () => {
        console.log("!isFetchingQuestion", !isFetchingQuestion);
        if (!isAudioplaying && !isFetchingQuestion) {
            if (recordingPermission && !pauseRecord) {
                // Ensure clean start
                SpeechRecognition.stopListening();
                setTimeout(() => {
                    SpeechRecognition.startListening({
                    continuous: true,
                    language: "en",
                    });
                    setMicrophone(true);
                }, 100);
            } else {
                alert("Your interview will begin after permission to screen record.");
            }
        }
    };

    function isFullScreenMode() {
        return !!(
            document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement
        );
    }

    async function getStreamAudio(audioContent) {
        if (audioContent) {
            setIsMicDisabled(true);
            SpeechRecognition.stopListening();
            isAudioplaying = true;
            setMicrophone(false);
            let audioContentData = audioContent;
            const audioData = base64ToArrayBuffer(audioContentData);

            audioContext.decodeAudioData(audioData, (buffer) => {
                const source = audioContext.createBufferSource();
                source.buffer = buffer;
                source.connect(audioContext.destination);
                const gainNode = audioContext.createGain();
                gainNode.gain.value = 1;

                source.connect(gainNode);
                gainNode.connect(audioContext.destination);
                gainNode.connect(aiAudioDestination);
                setAiAudioStream(aiAudioDestination.stream);
                source.start(0);
                setAudioSource(source);
                
                const statusCheckInterval = setInterval(() => {}, 100);
                
                source.onended = () => {
                    clearInterval(statusCheckInterval);
                    isAudioplaying = false;
                    setIsMicDisabled(false);
                    
                    // Check fullscreen
                    if (isFullScreenMode()) {
                        setTimeout(() => {
                            resetTranscript();
                            setAccumulatedTranscript("");
                    
                            // FIX: Get interview status and handle all edge cases
                            const currentInterviewStatus = localStorage.getItem("interview_status");
                            
                            // Check if interview is active
                            // Consider it active if:
                            // 1. startRecord is true, OR
                            // 2. status is "in_progess" or "in_progress", OR
                            // 3. status is undefined/null (treat as active during resume)
                            const interviewActive = startRecord || 
                                                currentInterviewStatus === "in_progess" || 
                                                currentInterviewStatus === "in_progress" ||
                                                !currentInterviewStatus ||
                                                currentInterviewStatus === "undefined" ||
                                                currentInterviewStatus === "null";
                            
                            console.log("Mic enable check1:", {
                                recordingPermission,
                                pauseRecord,
                                isFetchingQuestion,
                            });
                            console.log("Mic enable check2:", {
                                isAudioplaying,
                                startRecord,
                                currentInterviewStatus,
                                interviewActive,
                                shouldEnableMic: recordingPermission && !pauseRecord && interviewActive
                            });
                    
                            if (recordingPermission && !pauseRecord && interviewActive) {
                                console.log("Enabling microphone...");
                                SpeechRecognition.stopListening();
                                setTimeout(() => {
                                    SpeechRecognition.startListening({
                                        continuous: true,
                                        language: "en",
                                    });
                                    setMicrophone(true);
                                    console.log("Microphone enabled!");
                                }, 100);
                            } else {
                                console.error("Cannot start mic - conditions not met:", {
                                    recordingPermission,
                                    pauseRecord,
                                    interviewActive
                                });
                            }
                        }, 300);
                    }
                };
            });
        } else {
            isAudioplaying = false;
            setIsMicDisabled(false);
            if (isFullScreenMode()) {
                setTimeout(() => {
                    setMicrophone(true);
                    listenContinuously();
                }, 300);
            }
        }
    }

  function stopAudioValue() {
    if (audioSource) {
      audioSource.stop();
      audioContext.close();
    }
  }

  function audioOff() {
    SpeechRecognition.stopListening();
    setMicrophone(false);
  }

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setAiAudioPlay(false);
    }
  };

  const endInterviewCall = async () => {
    let data = {
      session_id: current_session_id,
      interview_timing_id: parseInt(interview_timing_id),
    };

    const JsonData = {
      url: endPoint.AUTOSCREEN_END,
      method: "post",
      data: JSON.stringify(data),
    };
    var apiResponse = await apiCall(JsonData);
    if (apiResponse?.return_code === "call_ended_success") {
      localStorage.setItem("interview_status", "completed");
    } else {
    }
  };

  const handlePopupCall = async (e) => {
    if (endcallPopup == false) {
      setEndcallPopup(true);
    }
  };

  const endcallPopupResponse = (response) => {
    if (response === "yes") {
      setIsOpen(false);
      handleEndCallClick();
    } else {
      setEndcallPopup(false);
    }
  };

  // Submit final answer without fetching next question (for timer expiration)
  const submitFinalAnswer = async (userAnswer) => {
    const currentQuestionId = parseInt(
      localStorage.getItem("autoscreen_curr_que")
    );

    if (!currentQuestionId) {
      console.log("No current question to submit answer for");
      return;
    }

    const now = new Date();
    const formattedTime = formatDate(now);

    let answerData = {
      question_id: currentQuestionId,
      answer: userAnswer,
      answer_timestamp: formattedTime,
    };

    const JsonData = {
      url: endPoint.AUTOSCREEN_UPDATE_ANSWER,
      method: "post",
      data: JSON.stringify(answerData),
    };

    // Submit answer and wait for completion
    const answerResponse = await apiCall(JsonData);

    // CRITICAL FIX: Validate answer was saved successfully
    console.log("Timer auto-submit response:", {
      currentQuestionId,
      answer: userAnswer,
      response: answerResponse
    });

    // Check if the API call failed at network level
    if (answerResponse?.error && !answerResponse?.success) {
      console.error("Failed to submit final answer (timer - network error):", answerResponse);
      throw new Error(answerResponse?.message || "Failed to save your final answer.");
    }

    // Check if server returned an error return_code
    if (answerResponse?.return_code && answerResponse.return_code.includes("error")) {
      console.error("Failed to submit final answer (timer - server error):", answerResponse);
      throw new Error(answerResponse?.message || "Server failed to save your final answer.");
    }

    console.log("Final answer submitted to API for question:", currentQuestionId);
  };

  // Auto-submit accumulated transcript and end interview (called when timer expires)
  const autoSubmitAndEndInterview = async () => {
    console.log("Timer expired - auto-submitting and ending interview");

    // STEP 1: Stop microphone immediately
    SpeechRecognition.stopListening();
    setIsMicDisabled(true);
    setMicrophone(false);

    // STEP 2: Check if there's accumulated transcript to submit
    const transcriptToSubmit = accumulatedTranscript.trim();

    if (transcriptToSubmit) {
      console.log("Submitting accumulated transcript:", transcriptToSubmit);

      try {
        // Submit the answer using submitFinalAnswer function with retry
        await submitFinalAnswer(transcriptToSubmit);
        console.log("Answer submitted successfully before timer end");

        // Clear the accumulated transcript after successful submission
        setAccumulatedTranscript("");
      } catch (error) {
        console.error("Error submitting answer on timer end:", error);

        // CRITICAL: Even if submission fails, we've tried with retries
        // Log the error but still end interview (timer already expired)
        // The retry mechanism in apiCall will have tried 3 times already
        console.error("Final answer may not have been saved. Check server logs.");
      }
    } else {
      console.log("No transcript to submit on timer end");
    }

    // STEP 3: End interview after submission attempt
    // Add small delay to ensure API call completes
    await new Promise(resolve => setTimeout(resolve, 500));
    await handleEndCallClick();
  };

  const handleEndCallClick = async () => {
    // Clear the timer interval when ending the call
    if (timerRef.current) {
        clearInterval(timerRef.current);
    }

    setCurrentInterviewStatus("completed");
    await endInterviewCall();
    if (webcamRef.current) {
      webcamRef.current = null;
    }
    setIsFullScreen(false);
    setPopupendCall(true);
    handle.exit();
    SpeechRecognition.stopListening();
    setAiAudioPlay(false);
    stopAudio();
    stopAudioValue();
    stop();
  };


useEffect(() => {
  // Only start timer if:
  // 1. Interview has started (startRecord is true)
  // 2. Timer data is loaded from API (isTimerLoaded is true)
  // 3. There is time remaining (timeRemaining > 0)
  if (startRecord && isTimerLoaded && timeRemaining > 0) {
    console.log("Starting timer:", timeRemaining, "seconds");
    
    // Clear any existing timer just in case
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    //GOOD: No reset, just start counting down
    timerRef.current = setInterval(() => {
      setTimeRemaining((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timerRef.current);
          console.log("Timer ended! Auto-submitting and ending interview");
          autoSubmitAndEndInterview();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  } else {
    // Clear interval if conditions not met
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  }

  // Cleanup on component unmount
  return () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  };
}, [startRecord, isTimerLoaded, timeRemaining]); // Better dependencies
  // Helper function to format seconds into MM:SS
  const formatTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    
    const paddedMinutes = String(minutes).padStart(2, '0');
    const paddedSeconds = String(seconds).padStart(2, '0');
    
    return `${paddedMinutes}:${paddedSeconds}`;
  };

  // --- End Interview Timer Implementation ---


  const handleClickEndCall = async () => {
    setIsFullScreen(false);
  };

  handleEndCallClickRef.current = handleEndCallClick;

  return (
    <>
      {endcallPopup && (
        <div className='popup'>
          <div
            className={`fixed inset-0 z-[10000] transition-opacity ${
              endcallPopup
                ? "ease-out duration-300 opacity-100"
                : "ease-in duration-200 opacity-0"
            }`}
            aria-labelledby='modal-title'
            role='dialog'
            aria-modal='true'
          >
            <div className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity'></div>

            <div className='fixed inset-0 z-10 w-screen overflow-y-auto'>
              <div className='flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'>
                <div
                  className={`relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg ${
                    endcallPopup
                      ? "ease-out duration-300 opacity-100 translate-y-0 sm:scale-100"
                      : "ease-in duration-200 opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  }`}
                >
                  <div className='bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4'>
                    <div className='sm:flex items-center'>
                      <div className='mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10'>
                        <svg
                          className='text-red-600 w-6 h-6'
                          aria-hidden='true'
                          xmlns='http://www.w3.org/2000/svg'
                          fill='none'
                          viewBox='0 0 20 20'
                        >
                          <path
                            stroke='currentColor'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z'
                          />
                        </svg>
                      </div>
                      <div className='mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left'>
                        <h3
                          className='text-base font-semibold leading-6 text-gray-900'
                          id='modal-title'
                        >
                          Are you sure you want to exit interview?
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className='bg-white px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6'>
                    <button
                      type='button'
                      onClick={() => endcallPopupResponse("yes")}
                      className='inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto'
                    >
                      Yes
                    </button>
                    <button
                      type='button'
                      onClick={() => endcallPopupResponse("no")}
                      className='mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto'
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    {isOpen && validationMessage && (
        <div className='popup'>
            <div className='fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center'>
            <div className='bg-white rounded-lg shadow-lg p-6 max-w-sm w-full'>
                <h2 className='text-lg font-semibold text-gray-900 mb-2'>Message</h2>
                <p className='text-gray-700 mb-4'>{validationMessage}</p>

                <button
                onClick={() => {
                    setValidationMessage("");
                    setIsOpen(false);
                }}
                className='bg-green-500/80 hover:bg-green-600/90 p-2 rounded-full min-w-[80px] h-[50px] flex items-center justify-center transition-colors mx-auto'>
                OK
                </button>
            </div>
            </div>
        </div>
    )}

      {/* Display current transcript for user feedback */}
      {displayTranscript && (
        <div className='absolute top-4 left-4 right-20 bg-black/50 text-white p-3 rounded-lg z-20'>
          <p className='text-sm'>{displayTranscript}</p>
        </div>
      )}

      <div className='col-span-3 m-0 p-0'>
        <div className='w-full'>
          <div className='relative'>
            {/* Interview Timer Display */}
            {startRecord && isTimerLoaded && (
                <div className={`absolute top-4 right-4 p-2 rounded-lg z-10 font-bold ${timeRemaining <= 60 ? 'bg-red-600 text-white' : 'bg-blue text-white'}`}>
                    {formatTime(timeRemaining)}
                </div>
            )}
            
            <div className='inset-0 justify-center items-center'>
              <div
                className={`absolute bottom-0 left-1/2 transform -translate-x-1/2 m-3 z-10 flex gap-3 ${
                  isOpen ? "pointer-events-none opacity-50" : ""
                }`}
              >
                {/* Microphone Button */}
                <div className='bg-gray-100/50 p-2 rounded-full w-[50px] h-[50px] flex content-center justify-center'>
                  {listening ? (
                    <button
                      type='button'
                      onClick={() => audioOff()}
                      disabled={isMicDisabled}
                      className={`${
                        isMicDisabled ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                    >
                      <span className='relative flex'>
                        <span className='animate-ping absolute inline-flex w-full h-full text-center rounded-full bg-blue opacity-75'></span>
                        <img
                          src={microphone}
                          className='w-[25px] h-[25px]'
                          alt='Muted Microphone'
                        />
                      </span>
                    </button>
                  ) : (
                    <button
                      type='button'
                      onClick={listenContinuously}
                      disabled={isMicDisabled}
                      className={`${
                        isMicDisabled ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                    >
                      <img
                        src={microphoneSlash}
                        className='w-[25px] h-[25px]'
                        alt='Active Microphone'
                      />
                    </button>
                  )}
                </div>

                {/* Submit & Next Button - Show only if NOT last question */}
                {startRecord && !isLastQuestion && (
                    <div className='bg-green-500/80 hover:bg-green-600/90 p-2 rounded-full min-w-[80px] h-[50px] flex items-center justify-center transition-colors'>
                        <button
                        type='button'
                        onClick={handleNextQuestion}
                        disabled={isFetchingQuestion || isMicDisabled}
                        className={`text-white font-semibold text-sm px-3 w-full h-full ${
                            isFetchingQuestion || isMicDisabled
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        >
                        Submit & Next
                        </button>
                    </div>
                )}
                {/* Submit & Finish Button - Show only if last question */}
                {startRecord && isLastQuestion && (
                    <div className='bg-green-500/80 hover:bg-green-600/90 p-2 rounded-full min-w-[100px] h-[50px] flex items-center justify-center transition-colors'>
                        <button
                        type='button'
                        onClick={handleFinishInterview}
                        disabled={isFetchingQuestion || isMicDisabled}
                        className={`text-white font-semibold text-sm px-3 w-full h-full ${
                            isFetchingQuestion || isMicDisabled
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        >
                        Submit & Finish
                        </button>
                    </div>
                )}

                {/* Skip Button - Show only if NOT last question */}
                {startRecord && !isLastQuestion && (
                    <div className='bg-orange-500/80 hover:bg-orange-600/90 p-2 rounded-full min-w-[80px] h-[50px] flex items-center justify-center transition-colors'>
                        <button
                        type='button'
                        onClick={handleSkipQuestion}
                        disabled={isFetchingQuestion || isMicDisabled}
                        className={`text-white font-semibold text-sm px-3 w-full h-full ${
                            isFetchingQuestion || isMicDisabled
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        >
                        Skip
                        </button>
                    </div>
                )}

                {/* End Call Button */}
                {startRecord && (
                  <div className='bg-gray-100/50 p-2 rounded-full w-[50px] h-[50px] flex content-center justify-center'>
                    <button
                      type='button'
                      onClick={handlePopupCall}
                      disabled={stopDisable}
                    >
                      <span className='relative flex'>
                        <img
                          src={endCall}
                          className='w-[25px] h-[25px]'
                          alt='Stop Screen Record'
                        />
                      </span>
                    </button>
                  </div>
                )}
              </div>
              <Webcam
                ref={webcamRef}
                className='rounded-2xl video'
                audio={false}
                mirrored={true}
                videoConstraints={videoConstraints}
                onUserMediaError={() => {
                  console.log("error");
                }}
              />
            </div>
            <div className='absolute bottom-0 right-0 p-2.5'>
              <div className='lg:w-[170px] lg:h-[120px] w-[50px] h-[50px] rounded-md border-2 border-[#6baafa] text-white flex items-center justify-center rounded-full bg-[#4d514f] flex-shrink-0 lg:text-3xl text-1xl'>
                <span className='relative flex items-center justify-center'>
                  {aiAudioPlay && (
                    <span className='animate-ping absolute inline-flex w-full h-full text-center rounded-full border-2 border-zinc-500 opacity-75'></span>
                  )}

                  <div className='w-[50px] h-[50px] bg-[#6279ca] content-center rounded-full flex items-center justify-center z-[999]'>
                    RI
                  </div>

                  {aiAudioPlay && (
                    <span className='animate-ping absolute inline-flex w-[35px] h-[35px] text-center rounded-full bg-gray-500'></span>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Video;